import { useMessageApi } from "../../../../provider/AntdNotification";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";
import { Form, Input, Spin, Switch, InputNumber, Button, Card, Row, Col, DatePicker, Select } from "antd";
import React, { useEffect } from "react";
import UploadFoodImage from "../../../../lib/UploadFoodImage";
import { useBlogDetails, useSaveBlog } from "../../../../hooks/api/blog/hook";
import TextArea from "antd/es/input/TextArea";
import TinyMce from "../../../../utils/TinyMCE";
import { useAuthorList } from "../../../../hooks/api/author/hook";
import { formatDate, removeSpecialChars } from "../../../../lib/utils";
import dayjs from "dayjs";

interface Props {
  qData: any;
  id?: any;
  handleCancel: () => void;

}

const BlogForm: React.FC<Props> = ({ qData, id , handleCancel}) => {
  const [form] = Form.useForm();
  const message = useMessageApi();
  const isEditPage = Boolean(id);

  const { mutate: saveBlog, isPending } = useSaveBlog({ qData });
  const { data: blogDetails, isLoading } = useBlogDetails(id);
 
  const watchHeading = Form.useWatch("heading", form);
  
  console.log(blogDetails, "blog-details");

  useEffect(() => {
    if (isEditPage && blogDetails?.data) {
      form.setFieldsValue({
        ...blogDetails.data,
        date: blogDetails.data.date ? dayjs(blogDetails.data.date) : null,
      });
    }
  }, [isEditPage, blogDetails, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        ...values,
        date: formatDate(values.date),
      }
      saveBlog(
        { ...payload, _id: id },
        {
          onSuccess: () => {
            message.success(
              isEditPage
                ? "Blog updated successfully"
                : "Blog created successfully",
            );
            handleCancel();
          },
          onError: (error) => {
            console.log(error, "error-saving-blog");
          },
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  const showSpinner = isEditPage && isLoading;

  const { data: data  } = useAuthorList({ isAll: true });
  const authors = data?.data || [];

   useEffect(() => {
      if (!isEditPage) {
        form.setFieldValue("slug", removeSpecialChars(watchHeading));
      }
    }, [watchHeading, isEditPage, form]);


  return (
    <div>
      <div className="bg-[#F9F9F9] p-3 md:p-6 rounded-2xl shadow-sm mb-6">
        <Spin spinning={showSpinner} tip="Loading Service details...">
         <Form form={form} layout="vertical">
             
             <Form.Item name="_id" hidden>
                <Input />
             </Form.Item> 

            <Form.Item
              label="Blog Title"
              name="heading"
              rules={[{ required: true, message: "Please enter blog title" }]}
            >
              <Input placeholder="Enter blog title" />
            </Form.Item>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Slug"
                  name="slug"
                  rules={[{ required: true, message: "Slug is required" }]}
                >
                  <Input placeholder="auto-generated" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Author"
                  name="authorId"
                  rules={[
                    { required: true, message: "Please select an author" },
                  ]}
                >
                  <Select
                    placeholder="Select author"
                    loading={authors.length === 0}
                    showSearch
                    optionFilterProp="children"
                  >
                    {authors.map((author) => (
                      <Select.Option key={author._id} value={author._id}>
                        {author.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Rest of your form fields (unchanged) */}
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item label="Publish Date" name="date">
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item label="Order Index" name="order">
                  <InputNumber min={0} style={{ width: "100%" }} placeholder="Enter order index" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item label="Short Description" name="shortDescription">
              <TextArea rows={2} placeholder="short description..." />
            </Form.Item>

            <Form.Item
              label="Full Description"
              name="description"
              rules={[
                { required: true, message: "Please enter blog description" },
              ]}
            >
              <TinyMce
                value={form.getFieldValue("description") || ""}
                onChange={(content) => {
                  form.setFieldsValue({ description: content });
                }}
                disable={false}
              />
            </Form.Item>

            <Form.Item
              label="Thumbnail Image"
              name="picture"
              rules={[
                { required: true, message: "Thumbnail required" },
              ]}
            >
              <UploadFoodImage maxUploadCount={1} />
            </Form.Item>

            <Form.Item label="Featured Image" name="featurePicture">
              <UploadFoodImage maxUploadCount={1} />
            </Form.Item>

            <Form.Item label="Meta Title" name="metaTitle">
              <Input placeholder="meta title" />
            </Form.Item>

            <Form.Item label="Meta Description" name="metaDescription">
              <TextArea rows={3} placeholder="meta description" />
            </Form.Item>

            <Form.Item label="Status" name="status" valuePropName="checked">
              <Switch checkedChildren="Published" unCheckedChildren="Draft" />
            </Form.Item>
          </Form>
        </Spin>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
        <ButtonWrapper type="primary" onClick={handleSave} loading={isPending}>
          Save
        </ButtonWrapper>
        <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
      </div>
    </div>
  );
};

export default BlogForm;
